import HackleClient from "./HackleClient"

/**
 * Legacy singleton holder for HackleClient.
 *
 * For backward compatibility, once initialized it always returns the first client
 * instance even when a different sdkKey is requested later.
 */
export class HackleClientHolder<T extends HackleClient> {
  private client: T | null = null

  getOrNull(): T | null {
    return this.client
  }

  get(): T {
    if (this.client === null) {
      throw new Error("HackleClient is not initialized yet")
    }

    return this.client
  }

  set(client: T): void {
    this.client = client
  }
}
